import React, { useCallback } from "react";
import { headerTypeComponent } from "./headerTypeMap";
import { AppSelector } from "redux/selector/app-selector";
import { useDispatch, useSelector } from "react-redux";
import { hideNotification, showNotification } from "redux/reducers/notification";

function MoneyConnectHeader() {
  const dispatch = useDispatch();
  const headerType = useSelector(AppSelector.headerType);
  const headerHeight = useSelector(AppSelector.headerHeight);

  const setNotificationVisible = useCallback(
    (visible) => {
      if (visible) {
        dispatch(showNotification());
      } else {
        dispatch(hideNotification());
      }
    },
    [dispatch]
  );

  const HeaderComponent = headerTypeComponent[headerType];
  return <HeaderComponent height={headerHeight} setIsVisible={setNotificationVisible} />;
}

export default MoneyConnectHeader;
